export enum JinroRoles {
  Jinro = "人狼",
  Murabito = "村人",
  Kyojin = "狂人",
  Uranaishi = "占い師",
  Reibaishi = "霊媒師",
  Karyudo = "狩人",
}
